const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20dramatic%20space%20battle%2C%20warm%20golden%20explosions%2C%20dark%20cosmic%20background%2C%20cinematic%20color%20grading%2C%20movie%20poster%20aesthetic%2C%20rich%20atmosphere%2C%20no%20text%2C%20epic%20scale&width=1200&height=600&seq=carousel-focus-01&orientation=landscape',
    title: '2024年度科幻盛典',
    desc: '从《流浪地球3》到《沙丘2》，盘点年度最震撼科幻巨制',
    tag: '年度专题',
    tagColor: 'bg-primary-500',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20and%20martial%20arts%20scene%2C%20warm%20golden%20lighting%2C%20dramatic%20cinematic%20composition%2C%20historical%20drama%20aesthetic%2C%20rich%20textures%2C%20film%20poster%20style%2C%20epic%20atmosphere%2C%20no%20text&width=1200&height=600&seq=carousel-focus-02&orientation=landscape',
    title: '古装权谋剧大赏',
    desc: '《庆余年3》《繁花》领衔，十部高分古装好剧不容错过',
    tag: '热门专题',
    tagColor: 'bg-accent-500',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20fantasy%20landscape%20with%20warm%20sunset%20colors%2C%20Japanese%20animation%20aesthetic%2C%20cinematic%20wide%20shot%2C%20golden%20hour%20lighting%2C%20dramatic%20clouds%2C%20rich%20atmosphere%2C%20film%20poster%20style%2C%20no%20text&width=1200&height=600&seq=carousel-focus-03&orientation=landscape',
    title: '日漫经典回顾',
    desc: '8090后的青春记忆，重温那些年陪伴我们的热血与感动',
    tag: '怀旧专题',
    tagColor: 'bg-secondary-500',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Suspenseful%20dark%20alley%20with%20warm%20neon%20reflections%2C%20film%20noir%20cinematic%20aesthetic%2C%20rainy%20night%20mood%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20movie%20poster%20style%2C%20rich%20textures%2C%20no%20text&width=1200&height=600&seq=carousel-focus-04&orientation=landscape',
    title: '悬疑烧脑片单',
    desc: '反转不停，智商碾压——高分悬疑电影精选推荐',
    tag: '精选专题',
    tagColor: 'bg-primary-500',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20dramatic%20spotlights%2C%20variety%20show%20aesthetic%2C%20dynamic%20warm%20lighting%2C%20concert%20vibe%2C%20cinematic%20wide%20composition%2C%20vibrant%20atmosphere%2C%20entertainment%20poster%20style%2C%20no%20text&width=1200&height=600&seq=carousel-focus-05&orientation=landscape',
    title: '综艺狂欢季',
    desc: '《乘风破浪》《奔跑吧》领衔，轻松欢乐的综艺时光',
    tag: '娱乐专题',
    tagColor: 'bg-accent-500',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20style%20romantic%20scene%20with%20warm%20autumn%20colors%2C%20cinematic%20composition%2C%20soft%20golden%20lighting%2C%20emotional%20atmosphere%2C%20beautiful%20scenery%2C%20film%20poster%20aesthetic%2C%20no%20text%2C%20rich%20tones&width=1200&height=600&seq=carousel-focus-06&orientation=landscape',
    title: '韩剧热播频道',
    desc: '高分韩剧一网打尽，从经典到新番的追剧指南',
    tag: '剧集专题',
    tagColor: 'bg-secondary-500',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选深度内容策划，发现更多值得看的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className={`inline-block text-xs px-3 py-1 rounded-full font-medium text-background-50 whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 line-clamp-1">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}